"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportTypeSwitchState = void 0;
const recoil_1 = require("recoil");
const ToggleButton_1 = __importDefault(require("@material-ui/lab/ToggleButton"));
const ToggleButtonGroup_1 = __importDefault(require("@material-ui/lab/ToggleButtonGroup"));
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const components_1 = require("@alcumus/components");
const react_i18next_1 = require("react-i18next");
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
exports.reportTypeSwitchState = (0, recoil_1.atom)({
    key: 'reportTypeSwitchState',
    default: reportElementTypes_1.ReportElementTypes.Dashboard,
});
const useStyles = (0, styles_1.makeStyles)({
    toggleText: {
        fontFamily: components_1.StyleVariables.fonts.family.body,
        fontHeight: components_1.StyleVariables.fonts.lineHeight.smaller,
        letterSpacing: components_1.StyleVariables.fonts.letterSpacing.regular,
        textTransform: 'capitalize',
        height: 32,
        fontWeight: components_1.StyleVariables.fonts.weight.semiBold,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.small,
        color: components_1.StyleVariables.colors.black,
        '&:focus': {
            color: components_1.StyleVariables.colors.white,
            backgroundColor: components_1.StyleVariables.colors.action.primary.default,
        },
        '&:active': {
            color: components_1.StyleVariables.colors.white,
            backgroundColor: components_1.StyleVariables.colors.action.primary.default,
        },
        '&$selected': {
            color: components_1.StyleVariables.colors.white,
            backgroundColor: components_1.StyleVariables.colors.action.primary.default,
            '&:hover': {
                color: components_1.StyleVariables.colors.white,
                backgroundColor: components_1.StyleVariables.colors.action.primary.default,
            },
        },
    },
    lookToggleText: {
        width: 70,
    },
    dashboardToggleText: {
        width: 108,
    },
    selected: {},
    buttonGroup: {
        height: '32px',
        '& > button:first-child': {
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
        },
        '& > button:last-child': {
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px',
        },
    },
});
function ReportTypeToggle({ t }) {
    const [toggle, setToggle] = (0, recoil_1.useRecoilState)(exports.reportTypeSwitchState);
    const classes = useStyles();
    const handleToggle = (event, newView) => {
        if (newView !== null) {
            setToggle(newView);
        }
    };
    return (react_1.default.createElement(ToggleButtonGroup_1.default, { value: toggle, exclusive: true, onChange: handleToggle, "aria-label": t('reportToggle', { ns: 'AriaLabels' }), className: classes.buttonGroup },
        react_1.default.createElement(ToggleButton_1.default, { classes: {
                root: `${classes.dashboardToggleText} ${classes.toggleText}`,
                selected: classes.selected,
            }, value: reportElementTypes_1.ReportElementTypes.Dashboard, "aria-label": t('dashboardReport', { ns: 'AriaLabels' }), "data-testid": "dashboardToggle" },
            react_1.default.createElement("div", null, t('dashboards', { ns: 'translation' }))),
        react_1.default.createElement(ToggleButton_1.default, { classes: {
                root: `${classes.lookToggleText} ${classes.toggleText}`,
                selected: classes.selected,
            }, value: reportElementTypes_1.ReportElementTypes.Look, "aria-label": t('lookReport', { ns: 'AriaLabels' }), "data-testid": "lookToggle" },
            react_1.default.createElement("div", null, t('looks', { ns: 'translation' })))));
}
exports.default = (0, react_i18next_1.withTranslation)(['translation', 'AriaLabels'])(ReportTypeToggle);
